module.exports = __webpack_public_path__ + "static/media/lovetrio.fd58367b.jpg";